const ThreeDSecureMode = {
  FULL_AUTHENTICATION: 'full_authentication',
  DATA_ONLY: 'data_only',
};

export default ThreeDSecureMode;
